import {useMutation, useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';

interface StatusResponse extends BackendResponse {
  linked: boolean;
  telegram_id?: number | null;
  telegram_linked_at?: string | null;
}

interface TokenResponse extends BackendResponse {
  token: string;
  expires_at: string;
}

interface UnlinkResponse extends BackendResponse {
  status: string;
}

export function useTelegramLinkStatus() {
  return useQuery({
    queryKey: ['telegram-link-status'],
    queryFn: () => fetchTelegramLinkStatus(),
  });
}

export function useTelegramLinkToken() {
  return useMutation({
    mutationFn: () => createTelegramLinkToken(),
    onError: err => showHttpErrorToast(err),
  });
}

export function useTelegramUnlink() {
  return useMutation({
    mutationFn: () => unlinkTelegram(),
    onError: err => showHttpErrorToast(err),
  });
}

function fetchTelegramLinkStatus() {
  return apiClient.get<StatusResponse>('telegram/link/status').then(r => r.data);
}

function createTelegramLinkToken() {
  return apiClient.post<TokenResponse>('telegram/link/token').then(r => r.data);
}

function unlinkTelegram() {
  return apiClient.post<UnlinkResponse>('telegram/link/unlink').then(r => r.data);
}
